import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { BatteryOptimization } from '@capawesome-team/capacitor-android-battery-optimization';

@Injectable({
  providedIn: 'root',
})
export class BatteryOptimizationService {
  async isBatteryOptimizationEnabled() {
    if (Capacitor.getPlatform() !== 'android') {
      return false;
    }
    const { enabled } = await BatteryOptimization.isBatteryOptimizationEnabled();
    return enabled;
  }

  async openBatteryOptimizationSettings() {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }
    await BatteryOptimization.openBatteryOptimizationSettings();
  }

  async requestIgnoreBatteryOptimization() {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }
    await BatteryOptimization.requestIgnoreBatteryOptimization();
  }
}
